import React, { useEffect, useState, useRef, lazy, memo } from 'react';
import { motion, AnimatePresence, PanInfo } from 'framer-motion';
import { XIcon, GridIcon, LayoutListIcon } from 'lucide-react';
const galleryImages = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/neMno9smxT4zSMR6M43EqH/b554f21dd2d902f0d204bee36d2a3486.jpg',
  alt: 'Vu A Dinh Scholarship Fund Award Ceremony',
  altVi: 'Lễ Trao Giải Quỹ Học Bổng Vừ A Dính',
  caption: 'Receiving scholarship recognition at Vu A Dinh Scholarship Fund ceremony for contributions to the fund',
  captionVi: 'Nhận giải thưởng học bổng tại lễ trao giải Quỹ Học Bổng Vừ A Dính cho những đóng góp cho quỹ',
  category: 'Leadership'
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/cWBCzM3jvrCnC9aN8QBZYm/IMG_3980.jpg',
  alt: 'Meeting with Former Vice President of Vietnam',
  altVi: 'Gặp gỡ với Cựu Phó Chủ tịch Việt Nam',
  caption: 'Meeting with the former Vice President of Vietnam to discuss youth development and education initiatives',
  captionVi: 'Gặp gỡ với Cựu Phó Chủ tịch Việt Nam để thảo luận về phát triển thanh niên và các sáng kiến giáo dục',
  category: 'Leadership'
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/4xtUgEtVtRB9hiFVwzcqz9/IMG_7347.jpg',
  alt: 'Friends Trip to Anaheim, CA',
  altVi: 'Chuyến đi Anaheim, CA cùng bạn bè',
  caption: 'Group trip with friends to Anaheim, California - making memories and exploring new places together',
  captionVi: 'Chuyến đi nhóm cùng bạn bè đến Anaheim, California - tạo kỷ niệm và khám phá những nơi mới cùng nhau',
  category: 'Travel'
}, {
  id: 4,
  src: 'https://cdn.magicpatterns.com/uploads/dgmyeFhEU7xd5bC4sPUC5t/IMG_4294.jpg.jpg',
  alt: 'With VinaCapital CEO',
  altVi: 'Cùng CEO VinaCapital',
  caption: 'Meeting with VinaCapital CEO during my summer internship in Ho Chi Minh City',
  captionVi: 'Gặp gỡ với CEO VinaCapital trong thời gian thực tập mùa hè tại Thành phố Hồ Chí Minh',
  category: 'Professional'
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/gM7fZZKbfKz5mmT9kjva62/IMG_1006.jpg',
  alt: 'Harvard University Summer School',
  altVi: 'Trường Hè Đại học Harvard',
  caption: 'Attending Harvard University summer school program - expanding knowledge and building connections',
  captionVi: 'Tham gia chương trình trường hè tại Đại học Harvard - mở rộng kiến thức và xây dựng mối quan hệ',
  category: 'Education'
}, {
  id: 6,
  src: 'https://cdn.magicpatterns.com/uploads/5TiKkMxKnJiRgMNF8EtxEr/B77C4D56-4CF1-4C56-A7A3-78057D47B050.jpg',
  alt: 'Halloween Party with Friends',
  altVi: 'Tiệc Halloween cùng Bạn bè',
  caption: 'Halloween celebration with friends - enjoying festive moments and creating fun memories',
  captionVi: 'Lễ hội Halloween cùng bạn bè - tận hưởng những khoảnh khắc lễ hội và tạo kỷ niệm vui vẻ',
  category: 'Travel'
}, {
  id: 7,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bEuKQaUikKg8C9R25fLZ8a/Screenshot_2025-09-08_at_11.19.51_PM.png',
  alt: 'Trung Nguyen with government official',
  altVi: 'Trung Nguyen với quan chức chính phủ',
  caption: 'Meeting with government officials to discuss immigration policy',
  captionVi: 'Gặp gỡ với các quan chức chính phủ để thảo luận về chính sách nhập cư',
  category: 'Leadership'
}, {
  id: 8,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tzEjKnU9beWeD8xaNdeagZ/AidWorks_Team.jpg',
  alt: 'AidWorks birthday celebration',
  altVi: 'Lễ kỷ niệm sinh nhật AidWorks',
  caption: 'AidWorks Foundation team celebrating my birthday',
  captionVi: 'Đội ngũ AidWorks Foundation tổ chức sinh nhật của tôi',
  category: 'AidWorks'
}, {
  id: 9,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uwdp1VMh5rPa1FUQuhM6Nz/DECA_Win.jpg',
  alt: 'DECA finalist picture',
  altVi: 'Hình ảnh chung kết DECA',
  caption: 'DECA International Finalist with my team',
  captionVi: 'Chung kết DECA Quốc tế cùng đội của tôi',
  category: 'Education'
}, {
  id: 10,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rv7J1FxSZz93vr9UqkUG8z/F1RST_Scholar.jpg',
  alt: 'F1RST Scholar',
  altVi: 'Học giả F1RST',
  caption: 'F1RST Scholars Program at Northeastern University',
  captionVi: 'Chương trình F1RST Scholars tại Đại học Northeastern',
  category: 'Education'
}, {
  id: 11,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kDduE12GVnBjGwNnLYBxsW/HCM_Intern_Mixer.jpg',
  alt: 'HCM Intern Mixer',
  altVi: 'Sự kiện giao lưu thực tập sinh HCM',
  caption: 'Ho Chi Minh City Finance Intern Mixer',
  captionVi: 'Sự kiện giao lưu Thực tập sinh Tài chính tại Thành phố Hồ Chí Minh',
  category: 'Professional'
}, {
  id: 12,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1pA8HFCnw1ffULCKY7Kccn/OCB_Team.jpg',
  alt: 'OCB Team',
  altVi: 'Đội OCB',
  caption: 'With the OCB FX Sales & Trading team in Ho Chi Minh City',
  captionVi: 'Cùng đội ngũ OCB FX Sales & Trading tại Thành phố Hồ Chí Minh',
  category: 'Professional'
}, {
  id: 13,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kry5e1AVVsViq1mL632Tfa/VNPress.png',
  alt: 'Vietnam Press Interview',
  altVi: 'Phỏng vấn Báo chí Việt Nam',
  caption: 'Being interviewed by Vietnamese press about scholarship initiatives',
  captionVi: 'Được phỏng vấn bởi báo chí Việt Nam về các sáng kiến học bổng',
  category: 'Leadership'
}, {
  id: 14,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3M2YsaBEgh5WbUNXg6Ssnk/With_Vice_President.jpg',
  alt: 'Meeting with Official',
  altVi: 'Gặp gỡ với Quan chức',
  caption: 'Formal meeting with government officials to discuss youth initiatives',
  captionVi: 'Cuộc họp chính thức với các quan chức chính phủ để thảo luận về các sáng kiến thanh niên',
  category: 'Leadership'
}, {
  id: 15,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1ASpzWLVqBaWXAj9BNmdcA/Dalat_2025.jpg',
  alt: 'Dalat Waterfall Trip',
  altVi: 'Chuyến đi thác Đà Lạt',
  caption: "Exploring Dalat's beautiful waterfalls with friends in 2025",
  captionVi: 'Khám phá những thác nước tuyệt đẹp ở Đà Lạt cùng bạn bè vào năm 2025',
  category: 'Travel'
}, {
  id: 16,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/goqzdGJ7hhwWyMSW8qpa5T/DECA.jpg',
  alt: 'DECA Conference',
  altVi: 'Hội nghị DECA',
  caption: 'DECA team at the business conference in formal attire',
  captionVi: 'Đội DECA tại hội nghị kinh doanh trong trang phục chính thức',
  category: 'Education'
}, {
  id: 17,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ixshGejZuRDbSPCBUbN2N9/Stephen_Kaufer_TripAdvisor_CEO_2.png',
  alt: 'Meeting with TripAdvisor CEO',
  altVi: 'Gặp gỡ với CEO TripAdvisor',
  caption: 'Networking with Stephen Kaufer, CEO of TripAdvisor',
  captionVi: 'Kết nối với Stephen Kaufer, Giám đốc điều hành của TripAdvisor',
  category: 'Professional'
}, {
  id: 18,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bute2X5CgBiAR4kNvkbZwa/student_government.jpg',
  alt: 'Student Government Team',
  altVi: 'Đội Chính phủ Sinh viên',
  caption: 'Leading the student government team during a school event',
  captionVi: 'Lãnh đạo đội ngũ chính phủ sinh viên trong một sự kiện trường học',
  category: 'Leadership'
}];
const PhotoGallery = ({
  language = 'en'
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState('All');
  const [filteredImages, setFilteredImages] = useState(galleryImages);
  const [viewMode, setViewMode] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < 768 ? 'carousel' : 'grid';
    }
    return 'grid';
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [exitDirection, setExitDirection] = useState<'left' | 'right' | null>(null);
  const lightboxRef = useRef(null);
  const sectionRef = useRef(null);
  // Translations for categories
  const categoryTranslations = {
    en: {
      All: 'All',
      Leadership: 'Leadership',
      AidWorks: 'AidWorks',
      Education: 'Education',
      Professional: 'Professional',
      Travel: 'Travel'
    },
    vi: {
      All: 'Tất cả',
      Leadership: 'Lãnh đạo',
      AidWorks: 'AidWorks',
      Education: 'Học vấn',
      Professional: 'Chuyên môn',
      Travel: 'Du lịch'
    }
  };
  const translations = {
    en: {
      photo: 'Photo',
      gallery: 'Gallery',
      fullArticle: 'Full Article',
      close: 'Close',
      gridView: 'Grid View',
      carouselView: 'Carousel View'
    },
    vi: {
      photo: 'Thư Viện',
      gallery: 'Hình Ảnh',
      fullArticle: 'Bài Viết Đầy Đủ',
      close: 'Đóng',
      gridView: 'Xem Lưới',
      carouselView: 'Xem Băng Chuyền'
    }
  };
  const t = translations[language];
  const categories = ['All', ...new Set(galleryImages.map(img => img.category))];
  useEffect(() => {
    if (activeFilter === 'All') {
      setFilteredImages(galleryImages);
    } else {
      setFilteredImages(galleryImages.filter(img => img.category === activeFilter));
    }
    setCurrentIndex(0);
  }, [activeFilter]);
  useEffect(() => {
    const handleClickOutside = event => {
      if (lightboxRef.current && !lightboxRef.current.contains(event.target)) {
        setSelectedImage(null);
      }
    };
    if (selectedImage) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [selectedImage]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.fade-in, .scale-in');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const openLightbox = image => {
    setSelectedImage(image);
  };
  const closeLightbox = () => {
    setSelectedImage(null);
  };
  const handleDragEnd = (event: any, info: PanInfo) => {
    const swipeThreshold = 100;
    const swipeVelocityThreshold = 500;
    if (Math.abs(info.offset.x) > swipeThreshold || Math.abs(info.velocity.x) > swipeVelocityThreshold) {
      if (info.offset.x > 0) {
        // Swiped right
        setExitDirection('right');
      } else {
        // Swiped left
        setExitDirection('left');
      }
      // Move to next image after animation
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % filteredImages.length);
        setExitDirection(null);
      }, 300);
    }
  };
  const currentImage = filteredImages[currentIndex];
  const nextImage = filteredImages[(currentIndex + 1) % filteredImages.length];
  return <section id="gallery" ref={sectionRef} className="w-full py-24 bg-secondary" data-id="element-1027">
      <div className="container mx-auto px-4" data-id="element-1028">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-8 fade-in" data-id="element-1029">
          {t.photo} <span className="gradient-text" data-id="element-1030">{t.gallery}</span>
        </h2>

        {/* View Toggle Button - Mobile Only */}
        <div className="flex justify-center mb-8 md:hidden" data-id="element-1031">
          <button onClick={() => setViewMode(viewMode === 'grid' ? 'carousel' : 'grid')} className="px-6 py-3 rounded-full bg-gradient-to-r from-accent-cyan to-accent-violet text-white font-medium shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95 flex items-center gap-2" data-id="element-1032">
            {viewMode === 'grid' ? <>
                <LayoutListIcon size={20} data-id="element-1033" />
                {t.carouselView}
              </> : <>
                <GridIcon size={20} data-id="element-1034" />
                {t.gridView}
              </>}
          </button>
        </div>

        {/* Category Filter */}
        <div className="mb-12 fade-in overflow-x-auto pb-2" data-id="element-1035">
          <div className="flex flex-nowrap justify-start md:justify-center gap-3 min-w-max md:min-w-0 px-1" data-id="element-1036">
            {categories.map((category, index) => <button key={index} onClick={() => setActiveFilter(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${activeFilter === category ? 'bg-gradient-to-r from-accent-cyan to-accent-violet text-white shadow-lg transform scale-105' : 'bg-background text-muted hover:text-primary hover:bg-background/80'}`} data-id="element-1037">
                {categoryTranslations[language][category] || category}
              </button>)}
          </div>
        </div>

        {/* Tinder-Style Swipe Carousel - Mobile Only */}
        {viewMode === 'carousel' && <div className="md:hidden relative px-2" data-id="element-1038">
            <div className="relative h-[500px] flex items-center justify-center" data-id="element-1039">
              {/* Card Stack */}
              <div className="relative w-full max-w-sm h-full" data-id="element-1040">
                <AnimatePresence mode="wait" data-id="element-1041">
                  {/* Next card (background) */}
                  {nextImage && <motion.div key={`next-${nextImage.id}`} className="absolute inset-0 w-full" initial={{
                scale: 0.9,
                opacity: 0.5
              }} animate={{
                scale: 0.95,
                opacity: 0.7
              }} style={{
                zIndex: 1
              }} data-id="element-1042">
                      <div className="overflow-hidden rounded-2xl bg-background shadow-xl h-full" data-id="element-1043">
                        <div className="aspect-[3/4] overflow-hidden" data-id="element-1044">
                          <img src={nextImage.src} alt={language === 'en' ? nextImage.alt : nextImage.altVi} className="w-full h-full object-cover" loading="lazy" data-id="element-1045" />
                        </div>
                        <div className="p-4" data-id="element-1046">
                          <div className="inline-block px-3 py-1 mb-2 text-xs font-medium bg-accent-cyan/20 text-accent-cyan rounded-full" data-id="element-1047">
                            {categoryTranslations[language][nextImage.category] || nextImage.category}
                          </div>
                          <p className="text-primary font-medium line-clamp-2" data-id="element-1048">
                            {language === 'en' ? nextImage.caption : nextImage.captionVi}
                          </p>
                        </div>
                      </div>
                    </motion.div>}

                  {/* Current card (foreground) */}
                  {currentImage && !exitDirection && <motion.div key={`current-${currentImage.id}`} className="absolute inset-0 w-full cursor-grab active:cursor-grabbing" drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.7} onDragEnd={handleDragEnd} initial={{
                scale: 1,
                opacity: 1,
                rotate: 0
              }} animate={{
                scale: 1,
                opacity: 1,
                rotate: 0
              }} exit={{
                x: exitDirection === 'right' ? 500 : -500,
                opacity: 0,
                rotate: exitDirection === 'right' ? 25 : -25,
                transition: {
                  duration: 0.3,
                  ease: 'easeOut'
                }
              }} whileDrag={{
                scale: 1.05,
                rotate: 0,
                cursor: 'grabbing'
              }} style={{
                zIndex: 2
              }} onClick={() => openLightbox(currentImage)} data-id="element-1049">
                      <div className="overflow-hidden rounded-2xl bg-background shadow-2xl h-full border-2 border-white/10" data-id="element-1050">
                        <div className="aspect-[3/4] overflow-hidden" data-id="element-1051">
                          <img src={currentImage.src} alt={language === 'en' ? currentImage.alt : currentImage.altVi} className="w-full h-full object-cover pointer-events-none" loading="lazy" data-id="element-1052" />
                        </div>
                        <div className="p-4" data-id="element-1053">
                          <div className="inline-block px-3 py-1 mb-2 text-xs font-medium bg-accent-cyan/20 text-accent-cyan rounded-full" data-id="element-1054">
                            {categoryTranslations[language][currentImage.category] || currentImage.category}
                          </div>
                          <p className="text-primary font-medium line-clamp-2" data-id="element-1055">
                            {language === 'en' ? currentImage.caption : currentImage.captionVi}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </div>

            {/* Swipe Hint */}
            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="text-center mt-6 text-muted text-sm" data-id="element-1056">
              ← Swipe to browse →
            </motion.div>

            {/* Carousel Indicators */}
            <div className="flex justify-center gap-2 mt-4 flex-wrap px-4" data-id="element-1057">
              {filteredImages.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-accent-cyan w-6' : 'bg-gray-300 dark:bg-gray-700 w-2'}`} aria-label={`Go to image ${index + 1}`} data-id="element-1058" />)}
            </div>
          </div>}

        {/* Grid View - Always visible on desktop, conditional on mobile */}
        <div className={`${viewMode === 'carousel' ? 'hidden md:grid' : 'grid'} grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6`} data-id="element-1059">
          {filteredImages.map((image, index) => <div key={image.id} className="scale-in overflow-hidden rounded-xl bg-background card-glow cursor-pointer transform transition-all duration-500 hover:scale-105" style={{
          animationDelay: `${index * 100}ms`
        }} onClick={() => openLightbox(image)} data-id="element-1060">
              <div className="aspect-[4/3] overflow-hidden" data-id="element-1061">
                <img src={image.src} alt={language === 'en' ? image.alt : image.altVi} className="w-full h-full object-cover transition-transform duration-700 hover:scale-110" loading="lazy" data-id="element-1062" />
              </div>
              <div className="p-4" data-id="element-1063">
                <div className="inline-block px-3 py-1 mb-2 text-xs font-medium bg-accent-cyan/20 text-accent-cyan rounded-full" data-id="element-1064">
                  {categoryTranslations[language][image.category] || image.category}
                </div>
                <p className="text-primary font-medium" data-id="element-1065">
                  {language === 'en' ? image.caption : image.captionVi}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && <div className="fixed inset-0 bg-background/95 z-50 flex items-center justify-center p-2 sm:p-4" data-id="element-1066">
          <div ref={lightboxRef} className="relative max-w-5xl w-full bg-secondary rounded-2xl overflow-hidden card-glow flex flex-col md:flex-row max-h-[90vh]" data-id="element-1067">
            <button onClick={closeLightbox} className="absolute top-4 right-4 z-10 bg-background/50 rounded-full p-2 text-primary hover:text-accent-cyan transition-colors" aria-label={t.close} data-id="element-1068">
              <XIcon size={24} data-id="element-1069" />
            </button>
            <div className="w-full md:w-3/4 bg-background flex items-center justify-center" data-id="element-1070">
              <img src={selectedImage.src} alt={language === 'en' ? selectedImage.alt : selectedImage.altVi} className="w-full h-auto object-contain max-h-[50vh] md:max-h-[80vh]" data-id="element-1071" />
            </div>
            <div className="w-full md:w-1/4 p-6 flex flex-col justify-between overflow-y-auto" data-id="element-1072">
              <div data-id="element-1073">
                <div className="inline-block px-3 py-1 mb-3 text-sm font-medium bg-accent-cyan/20 text-accent-cyan rounded-full" data-id="element-1074">
                  {categoryTranslations[language][selectedImage.category] || selectedImage.category}
                </div>
                <h3 className="text-xl font-display font-bold mb-3" data-id="element-1075">
                  {language === 'en' ? selectedImage.alt : selectedImage.altVi}
                </h3>
                <p className="text-muted" data-id="element-1076">
                  {language === 'en' ? selectedImage.caption : selectedImage.captionVi}
                </p>
              </div>
            </div>
          </div>
        </div>}
    </section>;
};
export default PhotoGallery;